// For full API documentation, including code examples, visit http://wix.to/94BuAAs

$w.onReady(function () {
	//TODO: write your page related code here...

});



export function button149_click(event, $w) {
    $w('#box70').show();
	//Add your code for this event here: 
}